const PROFILE = 'PERFIL';
const PATTERN = 'PADRAO';

export {
  PROFILE,
  PATTERN,  
};
